import { useNavigate } from "react-router-dom"
import { Typography } from "@mui/material"
import kwikScoutLogo from "../assets/kwik-scout-logo.png"

const footerColumns = [
	{
		title: "Recursos",
		links: [
			{ label: "Blog", type: "external", href: "https://www.instant.com.br/blog/" },
			// { label: "Central de ajuda", type: "button", action: "home" },
			// { label: "Integrações", type: "button", action: "home" },
			// { label: "Relacionamento e automação", type: "button", action: "home" },
		],
	},
	{
		title: "Confira também",
		links: [
			{ label: "InstantVoice", type: "external", href: "https://www.instant.com.br/instant-voice/" },
			{ label: "Kwik", type: "external", href: "https://landing.kwik.app.br/kwik/" },
			{ label: "Cortex", type: "external", href: "https://cortex.instant.com.br/" },
		],
	},
	{
		title: "Empresa",
		links: [
			{ label: "Sobre nós", type: "external", href: "https://www.instant.com.br/institucional/" },
			{ label: "Carreiras", type: "external", href: "https://www.instant.com.br/trabalhe-conosco-vagas/" },
			{ label: "Cases de sucesso", type: "external", href: "https://www.instant.com.br/casos-de-sucesso/" },
			{ label: "Contato", type: "external", href: "https://wa.me/551140636100" },
		],
	},
]

const legalLinks = [
	{
		label: "Termos de uso e política de privacidade",
		href: "https://docs.google.com/document/d/1DR4vZmqvf54jyXgEpmbEgad66qM6rhZMul6roDNZTAo/preview",
	},
	// {
	// 	label: "Política de privacidade",
	// 	href: "https://docs.google.com/document/d/1DR4vZmqvf54jyXgEpmbEgad66qM6rhZMul6roDNZTAo/preview",
	// },
]

const LandingFooter = () => {
	const navigate = useNavigate()

	const handleFooterAction = (action) => {
		if (action === "home") {
			navigate("/")
		}
	}

	return (
		<footer className="landing-site-footer landing-full-bleed-section">
			<div className="landing-site-footer__inner">
				<div className="landing-site-footer__content">
					<div className="landing-site-footer__brand">
						<img
							src={kwikScoutLogo}
							alt="Kwik Scout by Instant Solutions"
							className="landing-site-footer__logo"
						/>
						<Typography component="p" className="landing-site-footer__description">
							Monitoramento inteligente de conversas de WhatsApp Corporativo
						</Typography>
					</div>

					<div className="landing-site-footer__columns">
						{footerColumns.map((column) => (
							<div key={column.title} className="landing-site-footer__column">
								<Typography component="h3" className="landing-site-footer__column-title">
									{column.title}
								</Typography>

								<div className="landing-site-footer__column-links">
									{column.links.map((link) => (
										link.type === "external" ? (
											<a
												key={link.label}
												href={link.href}
												target="_blank"
												rel="noopener noreferrer"
												className="landing-site-footer__link"
											>
												{link.label}
											</a>
										) : (
											<button
												key={link.label}
												type="button"
												onClick={() => handleFooterAction(link.action)}
												className="landing-site-footer__link landing-site-footer__link--button"
											>
												{link.label}
											</button>
										)
									))}
								</div>
							</div>
						))}
					</div>
				</div>

				<div className="landing-site-footer__divider" />

				<div className="landing-site-footer__bottom">
					<Typography component="p" className="landing-site-footer__copyright">
						© 2026 Instant Solutions. Todos os direitos reservados.
					</Typography>

					<div className="landing-site-footer__legal-links">
						{legalLinks.map((link) => (
							<a
								key={link.label}
								href={link.href}
								target="_blank"
								rel="noopener noreferrer"
								className="landing-site-footer__legal-link"
							>
								{link.label}
							</a>
						))}
					</div>
				</div>
			</div>
		</footer>
	)
}

export default LandingFooter
